const en = {
  language: 'en',
  messages: {
    WelcomeToIncorta: `Welcome to Incorta Documentation`,
    whatToDo: `Where would you like to go?`,
  },
}

export default en
